import React from "react";
import { SafeOperatingSpace } from "./Spaces/SafeOperatingSpace";
import { HighRiskSpace } from "./Spaces/HighRiskSpace";
import { PlanetaryBoundaryMarker } from "./Marker/PlanetaryBoundaryMarker";
import HighRiskMarker from "./Marker/HighRiskMarker";

import MarkerLabel from "./Marker/MarkerLabel";
import MarkerDot from "./Marker/MarkerDot";
import QuartileRange from "./Quartiles/QuartileRange";
import QuartileMain from "./Quartiles/QuartileMain";

interface BoxPlotProps {
  markerPercent: number; // Wert zwischen 0 und 4
  quartileRangeX: number; // Wert zwischen 0 und 4
  quartileRangeWidth: number; // Wert zwischen 0 und 4
  quartileMainX: number; // Wert zwischen 0 und 4
  quartileMainWidth: number; // Wert zwischen 0 und 4
}

export const BoxPlot: React.FC<BoxPlotProps> = ({
  markerPercent,
  quartileRangeX,
  quartileRangeWidth,
  quartileMainX,
  quartileMainWidth,
}) => (
  <div className="box-plot">
    <div className="box-plot__label">Current State</div>
    <MarkerLabel text="We are here" markerPercent={markerPercent} />
    <div className="box-plot__bar">
      <SafeOperatingSpace />
      <HighRiskSpace />
      <PlanetaryBoundaryMarker />
      <HighRiskMarker />
      <QuartileRange x={quartileRangeX} width={quartileRangeWidth} />
      <QuartileMain x={quartileMainX} width={quartileMainWidth} />
      <MarkerDot markerPercent={markerPercent} />
    </div>
    <div className="box-plot__legend">
      <div className="planetary-boundary-marker__label">Planetary Boundary</div>
      <div className="high-risk-marker__label">High-Risk Line</div>
    </div>
  </div>
);
